import React, { Component } from 'react'
import { Button, Modal, Row } from 'antd'
import BankForm from '../Form/Banking/Bank'

class BankingModal extends Component {
  onChange = activeKey => {
    this.setState({ activeKey })
  }
  onEdit = (targetKey, action) => {
    this[action](targetKey)
  }
  add = () => {
    const panes = this.state.panes
    const activeKey = `newTab${this.newTabIndex++}`
    panes.push({
      title: 'New Bank Account',
      content: [<BankForm employee={this.props.employee}/>],
      key: activeKey,
    })
    this.setState({ panes, activeKey })
  }
  operations = (<Button onClick={this.add}>ADD BANK ACCOUNT</Button>)

  remove = targetKey => {
    let activeKey = this.state.activeKey
    let lastIndex
    this.state.panes.forEach((pane, i) => {
      if (pane.key === targetKey) {
        lastIndex = i - 1
      }
    })
    const panes = this.state.panes.filter(pane => pane.key !== targetKey)
    if (lastIndex >= 0 && activeKey === targetKey) {
      activeKey = panes[lastIndex].key
    }
    this.setState({ panes, activeKey })
  }

  constructor (props) {
    super(props)
    this.newTabIndex = 0
    const panes = [
      {
        title: 'Maybank Cheque Account',
        key: '1',
        content: [],
      },
    ]
    this.state = {
      activeKey: panes[0].key,
      panes,
      formLayout: 'horizontal',
    }
  }

  handleFormLayoutChange = e => {
    this.setState({ formLayout: e.target.value })
  }

  render () {
    const { visible, handleCancel, member, employee, bank, type } = this.props
    return (
      <Modal
        title={type === 'edit' ? 'Update Bank Details' : 'Add New Bank'}
        destroyOnClose={true}
        visible={visible}
        onCancel={handleCancel}
        width={900}
        footer={null}>
        <div>
          <Row style={{ marginTop: 10 }}>
            <BankForm
              bank={bank}
              handleCancel={handleCancel}
              member={member}
              type={type}
              employee={employee}
            />
          </Row>
        </div>
      </Modal>
    )
  }
}

BankingModal.defaultProps = {
  employee: {},
  member: {},
}
export default BankingModal
